module.exports = __webpack_public_path__ + "media/images/file-icons/128/004-folder-1-3a5edb699ebf6c157c01cfa10869a78d.png";